import styled from "styled-components";

export const AditionalContent = styled.div`
    background-color: ${props => props.bgColor ? props.bgColor : "#CCC"};
    padding: 10px 15px;
`;

const text = styled.div`
    color: ${({ theme }) => theme.color.white};
    text-shadow: 0 4px 8px rgba(150,150,150,0.1);
`

export const Title = styled(text)`
    font-size: 0.75rem;
    font-weight: ${({ theme }) => theme.fontWeight.fw700};
`;

export const Text = styled(text)`
    font-size: 1rem;
    font-weight: ${({ theme }) => theme.fontWeight.fw400};
`;
